firebird.controller('meetingLockedWaitingForApprovalCtrl', [
    '$scope',
    'meetingService',
    'helperService',
    'notificationService',
    'desktopNotificationService',
    'localizationService',
    function (
        $scope,
        meetingService,
        helperService,
        notificationService,
        desktopNotificationService,
        localizationService
    ) {
        var self = this;

        self.messageFromHost = null;
        self.getAppLogoURL = meetingService.getAppLogoURL;
        self.meeting = meetingService.getCurrentMeeting();
        self.showMessageFromHostDesktopNotification = showMessageFromHostDesktopNotification;

        $scope.$on('message-to-waiting-room', onMessageToWaitingRoom);

        function onMessageToWaitingRoom(e, data) {
            if (data && data.message) {
                var message = helperService.encodeHtml(data.message.trimRight());
                if (!!message && self.messageFromHost !== message) {
                    self.messageFromHost = message;
                    self.showMessageFromHostDesktopNotification();
                    digest();
                }
            }
        }

        function showMessageFromHostDesktopNotification() {
            if (notificationService.canShowDesktopNotification()) {
                desktopNotificationService.show(
                    localizationService.translate('JOIN_REQUEST_LIST.DESKTOP_NOTIFICATIONS.MESSAGE_FROM_HOST')
                );
            }
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
